import React from 'react';
import PropTypes from 'prop-types';

import classes from './HambergerBtn.css';

const hambergerBtn = props => {
  const { sideMenuHandler } = props;
  return (
    <div className={classes.HambergerBtn} onClick={sideMenuHandler}>
      <div />
      <div />
      <div />
    </div>
  );
};

hambergerBtn.propTypes = {
  sideMenuHandler: PropTypes.func
};

export default hambergerBtn;
